/**
 * Known Event Status IDs
 *
 * Predefined status values for events.
 */
export const EventStatusIDs = {
    /** Event is in draft status */
    DRAFT: 0,
    /** Event is scheduled */
    SCHEDULED: 1,
    /** Event is currently ongoing */
    ONGOING: 2,
    /** Event has been completed */
    COMPLETED: 3,
    /** Event has been cancelled */
    CANCELLED: -1,
    /** Event has been postponed */
    POSTPONED: -2,
    /** Event has been archived */
    ARCHIVED: -99,
};
//# sourceMappingURL=EventStatus.js.map